<template>
  <div class="ui attached secondary segment panel">
    <div
      v-for="group in buttons"
      :key="group.identifier"
      class="ui buttons button group"
    >
      <span
        v-for="button in group"
        :key="button.identifier"
      >
        <control-panel-button
          v-if="button.visibility !== 'hidden'"
          :icon="button.icon"
          :identifier="button.identifier"
          :title="button.title"
          @button-click="handleClick"
          @rate-selected="handleSelection"
        />
      </span>
    </div>
    <span />
    <owal-speed-picker
      class="speedpicker"
      @rate-selected="handleSelection"
    />
  </div>
</template>
<script>
import { buttons } from '@/libraries/controlpanel/buttons'
import OwalSpeedPicker from './control-panel/OwalSpeedPicker'
import ControlPanelButton from './controlPanelButton'
export default {
  name: 'ControlPanel',
  components: { ControlPanelButton, OwalSpeedPicker },
  data: function () {
    return {
      working: false,
    }
  },
  computed: {
    buttons: function () {
      return buttons
    },
    component: function () {
      return this.$options.components.controlPanelButton
    },
  },
  methods: {
    handleClick: function (identifier, oldIndex, currentIndex) {
      this.$emit('click', identifier, oldIndex, currentIndex)
    },
    handleSelection: function (selected) {
      this.$emit('rate-selected', selected)
    },
  },
}
</script>
<style scoped>
@media only screen and (max-width: 500px) {
  .button.group {
    margin-left: 0 !important;
  }

  .panel {
    padding-bottom: 20px !important;
  }
}

@media only screen and (max-width: 736px ) and (orientation: landscape){
  .button.group {
    margin-top: 0 !important;
  }
  .panel {
    padding-top: 10px !important;
    padding-bottom: 40px !important;
  }
}

.ui.segment {
  margin-bottom: 0 !important;

}

.panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  border: none;
}

.ui.huge.button {
  border: none;
  background: none !important;
}

.button.group {
  margin-left: 20%;
  background: none !important;
  flex-direction: row;
  align-items: center;
  align-content: center;

}

.button.group:hover {
  background: none !important;
}
</style>
